export default {
  sitemaps: [],
};
